'use strict';

var _ = require('lodash');
var NetSpillRateChart = function NetSpillRateChart(AbstractChart, chartGroups, chartSimpleBars, chartXAxis, chartYAxis, chartConstants, chartVerticalLine) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('class', formatters.tooltipFormatter, true);
    var actualRateBar = chartSimpleBars('actualRate');
    var optimalRateBar = chartSimpleBars('optimalRate');
    var topAxis = chartXAxis(formatters.xAxisTickFormatter).topMode();
    var bottomAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var verticalLine = chartVerticalLine('value');
    this.render = function (data) {
      this.initChart(data, undefined, chartParams(data.length));
      this.scales = chartScales(this.params, this.data);
      var barHeight = this.scales.yScale.rangeBand();
      var verticalLinesData = _.map(this.scales.xScale.ticks(), function (element) {
        return {
          value: element
        };
      });
      optimalRateBar.withHeight(barHeight * 0.6);
      optimalRateBar.withShift(barHeight * 0.2);
      this.preDataGroup.call(verticalLine.withData(verticalLinesData).params(this.params).scales(this.scales));
      this.callForDataGroup([groups, topAxis, bottomAxis, yAxis, actualRateBar, optimalRateBar], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
NetSpillRateChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleHorizontalBars', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsVerticalLine'];
module.exports = NetSpillRateChart;